import {useParams, useSearchParams} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {Tabs, TabsContent, TabsList, TabsTrigger} from '@/components/ui/tabs'
import {PageHeading} from '@/components/page-heading'
import {EmployeeIncapacidadesSection} from '@/components/employee-incapacidades-section'
import {useBusiness} from '@/hooks/empresa/organizacion/use-businesses'
import {useMyEmployee} from '@/hooks/empresa/identidad/use-employees'
import {MiFichaBody} from '@/pages/empresa/identidad/mi-ficha'
import {MiPerfilSociodemograficoBody} from '@/pages/empresa/mi_espacio/mi-perfil-sociodemografico'

type TabKey = 'ficha' | 'sociodemografico' | 'incapacidades'

function parseTab(value: string | null): TabKey | null {
  return value === 'ficha' || value === 'sociodemografico' || value === 'incapacidades' ? value : null
}

export function MiInformacionPage() {
  const {t} = useTranslation()
  const {businessId} = useParams()
  const {data: business} = useBusiness(businessId)
  const {data: me} = useMyEmployee(businessId)
  const [searchParams, setSearchParams] = useSearchParams()

  const tab = parseTab(searchParams.get('tab')) ?? 'ficha'
  function setTab(next: TabKey) {
    setSearchParams(
      (prev) => {
        const params = new URLSearchParams(prev)
        params.set('tab', next)
        return params
      },
      {replace: true}
    )
  }

  return (
    <div className="mx-auto max-w-2xl space-y-5">
      <PageHeading title={t('miInformacion.title')} subtitle={business?.name} />

      <Tabs value={tab} onValueChange={(v) => setTab(v as TabKey)}>
        {/* Scroll en un contenedor aparte: en la lista, su `overflow` recortaría el subrayado del activo. */}
        <div className="overflow-x-auto">
          <TabsList className="min-w-max [&>button]:shrink-0">
            <TabsTrigger value="ficha" data-testid="tab-ficha">
              {t('miInformacion.tabs.ficha')}
            </TabsTrigger>
            <TabsTrigger value="sociodemografico" data-testid="tab-sociodemografico">
              {t('miInformacion.tabs.sociodemografico')}
            </TabsTrigger>
            <TabsTrigger value="incapacidades" data-testid="tab-incapacidades">
              {t('miInformacion.tabs.incapacidades')}
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="ficha" className="pt-4">
          <MiFichaBody businessId={businessId!} />
        </TabsContent>
        <TabsContent value="sociodemografico" className="pt-4">
          <MiPerfilSociodemograficoBody businessId={businessId!} />
        </TabsContent>
        <TabsContent value="incapacidades" className="pt-4">
          <EmployeeIncapacidadesSection businessId={businessId!} employeeId={me?.id ?? null} canOperate={false} />
        </TabsContent>
      </Tabs>
    </div>
  )
}
